// src/locales/en/deliveryNote.js
export const deliveryNote = {
  // Page titles
  deliveryNotes: 'Delivery Notes',
  allDeliveryNotes: 'All Delivery Notes',
  createDeliveryNote: 'Create Delivery Note',
  editDeliveryNote: 'Edit Delivery Note',
  deliveryNoteDetails: 'Delivery Note Details',
  viewAndManageAllDeliveryNotes: 'View and manage all delivery notes',
  createDeliveryNoteDescription: 'Record delivery of items from an offline sales order',
  officialDeliveryNote: 'Official Delivery Note',
  shop: 'Shop',
  allShops: 'All Shops',
  orderNotFound: 'Order not found',

  // List columns
  deliveryNoteNumber: 'Delivery Note #',
  originalOrder: 'Original Order',
  customer: 'Customer',
  deliveredBy: 'Delivered By',
  deliveredAt: 'Delivered At',
  receivedByName: 'Received By',
  createdBy: 'Created By',
  createdAt: 'Created At',
  status: 'Status',
  actions: 'Actions',
  orderNumber: 'Order Number',
  item: 'Item',
  details: 'Delivery Details',
  itemsToDeliver: 'Items to Deliver',
  itemsDelivered: 'Items Delivered',
  orderedQty: 'Ordered Quantity',
  remainingQty: 'Remaining Quantity',
  quantityDelivered: 'Quantity Delivered',
  unitsSelected: 'units selected',

  // Status labels — used via t(`deliveryNote.status_${note.status}`)
  status_pending:   'Pending',
  status_delivered: 'Delivered',
  status_cancelled: 'Cancelled',

  // Form fields
  selectOrder: 'Select Order',
  lookupOrder: 'Look Up Order',
  orderIdPlaceholder: 'Enter order ID or order number',
  lookupButton: 'Look Up',
  searchOrder: 'Search by order number or ID...',
  noOrdersFound: 'No orders found',
  warehouse: 'Warehouse',
  atLeastOneItemRequired: 'Please select at least one item',
  selectWarehouse: 'Select Warehouse',
  selectDeliveredBy: 'Select Delivery Person',
  receivedByNamePlaceholder: 'Enter name of person who received the delivery',
  deliveryAddress: 'Delivery Address',
  items: 'Items',
  quantityToDeliver: 'Quantity to Deliver',
  notes: 'Notes',
  notesPlaceholder: 'Add any notes about this delivery...',

  // Actions
  create: 'Create Delivery Note',
  save: 'Save',
  markAsDelivered: 'Mark as Delivered',
  cancelDeliveryNote: 'Cancel Delivery Note',
  edit: 'Edit',
  print: 'Print',
  printDeliveryNote: 'Print Delivery Note',
  backToDeliveryNotes: 'Back to Delivery Notes',

  // Confirmations
  confirmMarkDelivered: 'Confirm that this order has been delivered and received?',
  confirmCancel: 'Are you sure you want to cancel this delivery note?',
  cancellationReason: 'Reason for Cancellation',
  cancellationReasonPlaceholder: 'Enter reason for cancellation...',

  // Filters
  filterByStatus: 'Filter by Status',
  filterByWarehouse: 'Filter by Warehouse',
  filterByDeliveredBy: 'Filter by Delivery Person',
  dateFrom: 'From',
  dateTo: 'To',
  searchDeliveryNotes: 'Search by delivery note #, order #, customer...',
  allStatuses: 'All Statuses',
  allWarehouses: 'All Warehouses',

  // Success / error messages
  deliveryNoteCreatedSuccessfully: 'Delivery note created successfully',
  deliveryNoteUpdatedSuccessfully: 'Delivery note updated successfully',
  deliveryNoteDeliveredSuccessfully: 'Delivery note marked as delivered',
  deliveryNoteCancelledSuccessfully: 'Delivery note cancelled successfully',
  failedToCreateDeliveryNote: 'Failed to create delivery note',
  failedToUpdateDeliveryNote: 'Failed to update delivery note',
  failedToLoadDeliveryNotes: 'Failed to load delivery notes',
  failedToLoadDeliveryNoteDetails: 'Failed to load delivery note details',
  failedToLoadDeliveryNote: 'Failed to load delivery note',
  deliveryNoteCreatedSuccess: 'Delivery note {number} created successfully',
  someFieldsRequired: 'Please fix the highlighted fields before submitting',

  // Validation
  orderRequired: 'Please select an order',
  warehouseRequired: 'Please select a warehouse',
  receivedByNameRequired: 'Received-by name is required when marking as delivered',

  // Empty states
  noDeliveryNotesFound: 'No delivery notes found',
  noDeliveryNotesYet: 'No delivery notes yet.',
  noDeliveryNotesMatchFilters: 'No delivery notes match your current filters',
  noDeliveryNotesYetDescription: 'Create your first delivery note to record fulfillment.',
  noDeliveryNotesFoundDescription: 'No delivery notes match your current filters',
  createFirstDeliveryNote: 'Create First Delivery Note',

  na: 'N/A',
};
